import { type TableColumn } from "@kyan/ui";

import { ClickableInstrument } from "#/components/ClickableInstrument/ClickableInstrument";
import { type Position } from "#/types/positions";

import {
  getCommonColumns,
  type PositionColumnsProps,
} from "../../Positions.constants";
import { ClosePosition } from "../ClosePosition/ClosePosition";

export const getColumns = ({
  openSharePnlCardsModal,
}: PositionColumnsProps): TableColumn<Position>[] => [
  {
    id: "instrument",
    header: "Instrument",
    minWidth: "240px",
    cellClassName: "pl-15",
    columnClassName: "pl-15",
    cell: ({ instrument }) => <ClickableInstrument instrument={instrument} />,
  },
  ...getCommonColumns({ openSharePnlCardsModal }),
  {
    id: "close",
    header: "Close",
    minWidth: "75px",
    cell: (position) => <ClosePosition position={position} />,
  },
];
